const p="https://sandbox.kit.cash.app/v1/pay.js",s="https://kit.cash.app/v1/pay.js";export{s as CASHAPPPAY_PROD_SDK,p as CASHAPPPAY_SANDBOX_SDK};
//# sourceMappingURL=config.js.map
